import React from 'react';
import { ADD_BOOKMARK_ITEM, REMOVE_BOOKMARK_ITEM } from '../context/actions';
import { useDfContext } from '../context/df-context';

export function usePinned() {
  const { state, dispatch } = useDfContext();
  const { bookmarks } = state || {};

  const addPin = React.useCallback(
    (id, group) => {
      if (!bookmarks.find((item) => item.id === id)) {
        dispatch({
          type: ADD_BOOKMARK_ITEM,
          bookmark: { id, group },
        });
      }
    },
    [bookmarks, dispatch],
  );

  const removePin = React.useCallback(
    (id) => {
      dispatch({
        type: REMOVE_BOOKMARK_ITEM,
        id,
      });
    },
    [dispatch],
  );

  const togglePin = React.useCallback(
    (id, group) => {
      if (bookmarks.find((item) => item.id === id)) {
        removePin(id);
      } else {
        addPin(id, group);
      }
    },
    [addPin, bookmarks, removePin],
  );

  const isPinned = React.useCallback((id) => bookmarks.find((item) => item.id === id), [bookmarks]);

  return {
    pins: bookmarks,
    addPin,
    removePin,
    togglePin,
    isPinned,
  };
}
